import React from "react";
import NavBarComponent from "../../NavBarComponent";
import { internalLinks, links } from "./navigationData";

const index = () => {
  return <NavBarComponent links={links} internalLinks={internalLinks} />;
};

export default index;
